interface EmptyStateProps {
  icon: string;
  title: string;
  description?: string;
}

export default function EmptyState({ icon, title, description }: EmptyStateProps) {
  return (
    <div className="rounded-lg border border-dashed border-background-300 bg-background-50 p-10 md:p-14 flex flex-col items-center justify-center text-center">
      <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={`${icon} text-2xl`} aria-hidden="true"></i>
      </span>
      <p className="mt-4 font-heading font-semibold text-base text-foreground-700">{title}</p>
      {description && <p className="mt-1.5 text-sm text-foreground-500 max-w-md">{description}</p>}
    </div>
  );
}